import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoints, AnonymousRequestHeaderOptions } from '@core/constants';
import { MyOrganization } from '@core/models';
import { environment } from '@env';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionSecurityService } from '@shared/services';
import Helper from '../utils/Helper';

@Injectable({
  providedIn: 'root'
})
export class SearchorganizationService {

  public apiUrl = environment.apiHost;
  public readonly searchOrgUrl = this.apiUrl + '/Lookup/countries/';
  public readonly searchOtherMilteryOrgUrl = this.apiUrl + '/Lookup/OtherMiliteryorganizations/';
  public readonly sites = this.apiUrl + '/Lookup/GetSites/';
  searchOption = []
  public postsData: any[]

  countryID: number;
  stateID: number;
  constructor(
    private http: HttpClient,
    private sessionSecurity: SessionSecurityService
  ) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


  getOrganization(countryID: string, stateID?: string): Observable<any[]> {
    return this.http.get<any>(this.searchOrgUrl + `${countryID}/organizations?stateID=${stateID}`, this.httpOptions);
  }
  getOtherMiliteryOrganization(): Observable<any[]> {
    return this.http.get<any>(this.searchOtherMilteryOrgUrl, this.httpOptions);
  }

  getMyOrganizations(): Observable<MyOrganization[]> {
    let organizations =
      this.sessionSecurity.getObject<MyOrganization[]>('organizations');

    if (Helper.isNullOrEmpty(organizations)) {
      return this.http
        .get<MyOrganization[]>(ApiEndpoints.getMyOrganizations)
        .pipe(
          map((res) => {
            if (Helper.hasAny(res)) {
              this.sessionSecurity.setObject<MyOrganization[]>(
                res,
                'organizations'
              );
            }
            return res;
          }),
          catchError(
            this.handleError<MyOrganization[]>('getMyOrganizations', [])
          )
        );
    } else {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(organizations);
        }, 300);
      });
    }
  }



  getUserOrganizations(): Observable<MyOrganization[]> {
    let organizations = this.sessionSecurity.getObject<MyOrganization[]>('userOrganizations');

    if (Helper.isNullOrEmpty(organizations)) {
      return this.http
        .get<MyOrganization[]>(ApiEndpoints.getUserSearchOrganizations)
        .pipe(
          map((res) => {
            if (Helper.hasAny(res)) {
              this.sessionSecurity.setObject<MyOrganization[]>(
                res,
                'userOrganizations'
              );
            }
            return res;
          }),
          catchError(
            this.handleError<MyOrganization[]>('getUserOrganizations', [])
          )
        );
    } else {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(organizations);
        }, 300);
      });
    }
  }



  getSites(globlID: any): Observable<any[]> {
    return this.http.get<any>(this.sites + `${globlID}`, AnonymousRequestHeaderOptions)
  }

  /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


}
